import React from 'react';

import { INotificationGridItem } from '../notification-grid';

import { DetailsRow } from './DetailsRow';
import { LeadInfo } from './utils';

export const NewDepositPaymentMethodDetails: React.FC<
  INotificationGridItem
> = ({ date, notificationDetails: { data } }) => (
  <>
    <DetailsRow label="Date" value={date} />
    <DetailsRow
      label="Client ID"
      component={<LeadInfo leadId={data.leadId} />}
    />
    <DetailsRow label="Name" value={data.leadFullName} />
    <DetailsRow label="Transactions Sub Type" value={data.subTypeName} />
    {data.ccProcessor && (
      <DetailsRow label="CC Processor" value={data.ccProcessor} />
    )}
    <DetailsRow label="Transaction ID" value={data.transactionId} />
    {data.managerId && (
      <DetailsRow
        label="Manager ID"
        value={`${data.managerId}, ${data.managerName}`}
      />
    )}
  </>
);
